import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface Props {
    icon?: ReactNode;
    title: string;
    message?: string;
    action?: ReactNode;
    titleSx?: SxProps<Theme>;
}

export function EmptyState({ icon, title, message, action, titleSx }: Props) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1, py: 6, textAlign: 'center' }}>
            {icon && <Box sx={{ color: 'text.disabled', mb: 1 }}>{icon}</Box>}
            <Typography variant="body2" fontWeight={600} color="text.primary" sx={titleSx}>
                {title}
            </Typography>
            {message && (
                <Typography variant="caption" color="text.secondary">
                    {message}
                </Typography>
            )}
            {action && <Box sx={{ mt: 1 }}>{action}</Box>}
        </Box>
    );
}
